import * as React from "react";

interface Props {
  height: number
  width: number
  color: string
}

const TrashIcon = ({ height, width, color = 'currentColor', ...props }: Props) => (

  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={width}
    height={height}
    fill={color}
    {...props}
  >
    <defs>
      <style>{".cls-1{fill:none;}"}</style>
    </defs>
    <g id="Capa_2" data-name="Capa 2">
      <g id="Fondos_iconos" data-name="Fondos iconos">
        <rect className="cls-1" width={48} height={48} />
      </g>
      <g id="Iconos">
        <path
          className="cls-2"
          d="M38,6H34a2,2,0,0,0-2-2H16a2,2,0,0,0-2,2H10a4,4,0,0,0-4,4,2,2,0,0,0,2,2V40a4,4,0,0,0,4,4H36a4,4,0,0,0,4-4V12a2,2,0,0,0,2-2A4,4,0,0,0,38,6ZM36,38a2,2,0,0,1-2,2H14a2,2,0,0,1-2-2V12H36Z"
        />
        <path
          className="cls-2"
          d="M19,16a2,2,0,0,0-2,2V34a2,2,0,0,0,4,0V18A2,2,0,0,0,19,16Z"
        />
        <path
          className="cls-2"
          d="M29,16h0a2,2,0,0,0-2,2V34a2,2,0,0,0,4,0V18A2,2,0,0,0,29,16Z"
        />
      </g>
    </g>
  </svg>
);
export default TrashIcon;
